//@ts-check
import React from 'react';
import FormsPage from './FormsPage';

var FormsBootstrap = function FormsBootstrap(_ref) {
  var children = _ref.children,
      history = _ref.history,
      emailBlackList = _ref.emailBlackList,
      googleApiKey = _ref.googleApiKey,
      peopleMergeRules = _ref.peopleMergeRules,
      emailblacklistPath = _ref.emailblacklistPath,
      googleapikeyPath = _ref.googleapikeyPath,
      peopleMergeRulesPath = _ref.peopleMergeRulesPath;
  if (!history) return children;
  var location = history.location;
  if (typeof location.pathname !== 'string') return children;
  if (emailBlackList && location.pathname.toLowerCase().startsWith(emailblacklistPath)) return React.createElement(FormsPage, {
    history: history,
    location: location,
    pageName: "emailblacklist"
  });
  if (googleApiKey && location.pathname.toLowerCase().startsWith(googleapikeyPath)) return React.createElement(FormsPage, {
    history: history,
    location: location,
    pageName: "googleapikey"
  });
  if (peopleMergeRules && location.pathname.toLowerCase().startsWith(peopleMergeRulesPath)) return React.createElement(FormsPage, {
    history: history,
    location: location,
    pageName: "peoplemergerules"
  });
  return children;
};

FormsBootstrap.defaultProps = {
  emailblacklistPath: '/settings/forms/blacklist',
  googleapikeyPath: '/settings/forms/googleapikey',
  peopleMergeRulesPath: '/settings/forms/peoplemergerules',
  emailBlackList: false,
  googleApiKey: false,
  peopleMergeRules: false
};
export default FormsBootstrap;